<template>
    <div class="box">
        <div v-if="formData.productDesc.specialService">
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>产品特色</div>
            </div>
            <div class="content">
                <span></span>
                <div v-html="formData.productDesc.specialService"/>
            </div>
        </div>
        <div v-if="formData.productDesc.bookingDescription">
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>预定说明</div>
            </div>
            <div class="content">
                <span></span>
                <div v-html="formData.productDesc.bookingDescription"/>
            </div>
        </div>
        <div>
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>购买时间</div>
            </div>
            <div class="content">
                <span></span>
                <div class="item-p">{{forwardBuyContent}}</div>
            </div>
        </div>
        <div>
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>预订限制</div>
            </div>
            <div class="content">
                <span></span>
                <div v-html="reservationLimit" />
            </div>
        </div>
        <div>
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>支付方式</div>
            </div>
            <div v-if="typeof(advanceLimit)==='string'">
                <div class="content">
                    <span></span>
                    <div>{{advanceLimit}}</div>
                </div>
            </div>
            <div v-else class="advance-box">
                <span class="col-span"></span>
                <div class="content-box">
                    <div v-for="(item,index) in advanceLimit">
                        <div v-if="index===0" style="display:flex" class="advance-content">
                            <div class="advance-title">{{item.title}}</div>
                            <div class="content-text">
                                <span>首次支付按</span>
                                <span v-if="item.advanceBookingFeeType == '%'" style="color: #00479C">订单总额的{{item.advanceRatio}}{{item.advanceBookingFeeType}}</span>
                                <span v-else style="color: #00479C">{{item.advanceRatio}}{{item.advanceBookingFeeType}}/份</span>
                                <span>收取定金，</span>
                                <span>下单后<span style="color: #00479C">{{item.orderCancelTimehour}}</span>小时<span style="color: #00479C">{{item.orderCancelTimeMin}}</span>分内未支付订单将自动取消</span>
                            </div>
                        </div>
                        <div v-else style="display:flex" class="advance-content">
                            <div class="advance-title">{{item.title}}</div>
                            <div class="content-text">
                                <span v-if="item.allBookingType =='不限'">尾款支付时间不限</span>
                                <span v-else>
                                    尾款需在<span style="color: #00479C">{{item.allBookingType}}{{item.allBookingDate}}</span>天，<span style="color: #00479C">{{item.allBookingHours}}</span>点<span style="color:#00479C">{{item.allBookingMinute}}</span>分前完成尾款支付
                                </span>
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="title">
                <!-- <van-icon name="flag-o" color="#b5bccb"/> -->
                <div>退单规则</div>
            </div>
            <div class="rule">
                <span class="rule_span"></span>
                <div class="rule_content">
					<van-tag type="warning">{{ cancelFormat(formData.productRules.cancelType) }}</van-tag>  
                    <div v-if="formData.productRules.cancelType !== '2' && formData.productRules.cancelType !== '0'">
                        <span v-for="(item,index) in formData.productRules.cancelFeeRuleList" :key="index" >
                            <span v-if="item.isTimeLimit === '0'">{{item.cancelFeeValue || ''}} {{ cancelFeeTypeFormat(item.cancelFeeType)}}</span>
                            <span v-else>
                                <span v-if="item.cancelTimeRule =='1'">出团日期开始前 </span>
                                <span v-else-if="item.cancelTimeRule =='2'">回团日期截至前 </span>
                                <span v-else-if="item.cancelTimeRule =='3'">回团日期截止后 </span>
                                <span>
                                    <span v-if="item.cancelLimitDays!='0'">{{ item.cancelLimitDays }} 天</span>
                                    <span v-if="item.cancelLimitHour!='0'">在{{ item.cancelLimitHour }} 点</span>
                                    <span v-if="item.cancelLimitMinute!='0'">{{ item.cancelLimitMinute }} 分前</span>退款，
									<span v-if="item.cancelFeeValue">扣除手续费 {{ item.cancelFeeValue || '' }}</span>
									{{ cancelFeeTypeFormat(item.cancelFeeType)}}
                                </span>
                                <br />
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs';
  export default {
    name: 'line-explain',
    props: {
    //   lineNewData:{
    //     type:Object,
    //     default:()=>{}
    //   },
      productDesc: {
        type:Object,
        default:()=>{}
      },
      productRules: {
        type:Object,
        default:()=>{}
      }
    },
    data() {
      return {
        formData: {
            productDesc: {},
            productRules: {},
        }, // 行程信息
        cancelTypeOptions:[],
        cancelFeeTypeOptions:[]
      }
    },
    watch:{
        productDesc(val) {
            this.formData.productDesc = val;
        },
        productRules(val) {
            this.formData.productRules = val
        }
    },
    computed: {
        forwardBuyContent() {
            if (this.formData.productRules.forwardBuyType==='0') {
                return "用户任意时间均可购买"
            } else {
                const purchaseTime = dayjs().add(this.formData.productRules.forwardBuyDay, 'day')
					.add(this.formData.productRules.forwardBuyHour, 'hour')
					.add(this.formData.productRules.forwardBuyMinute, 'minute')
					.format('M月DD日');
                return `最早可定${purchaseTime}`
            }
        },
        reservationLimit() {
            const rules = this.formData.productRules;
            let orderLimit = `每笔订单最少预定${rules.orderNoMin}份，最多${+rules.orderNoMax > 0 ? rules.orderNoMax+'份':'无限制'}`;
            let phoneLimit = `同一手机号在${rules.phoneDays}天内，最多预定${+rules.phoneDaysMax > 0 ? rules.phoneDaysMax+'单':'无限制'}`;
            let IDCardLimit = `同一身份证号在${rules.certificateDays}天内，最多预定${+rules.certificateDaysMax > 0 ? rules.certificateDaysMax+'单':'无限制'}`;
            var content = `
						<div>${orderLimit}</div>
						<div>${phoneLimit}</div>
						<div>${IDCardLimit}</div>
					`
            return content
        },
        advanceLimit() {
            const rules = this.formData.productRules;
            if (rules.isAdvance === '1') {
                return "全款支付"
            }
            var listText = [
                {title: '定金', col:1, text: '首次支付按', advanceRatio: '', advanceBookingFeeType: '', orderCancelTimehour: '', orderCancelTimeMin:''},
                {title: '尾款', col:2, text: '尾款', allBookingType: '', allBookingDate: '', allBookingHours: '', allBookingMinute: '' }
            ];
            if (rules.advanceRatio) {
                listText[0].advanceRatio = rules.advanceRatio	
            }
            if (rules.advanceBookingFeeType) {
                var arr = ['元', '%'];
                listText[0].advanceBookingFeeType = arr[Number(rules.advanceBookingFeeType)]
            }
            if (rules.orderCancelTime) {
                listText[0].orderCancelTimehour = Math.floor(rules.orderCancelTime / 60)
                listText[0].orderCancelTimeMin = rules.orderCancelTime % 60
            }
            if (rules.allBookingType == 0) {
                listText[1].allBookingType = '不限'
            } else {
                var arr2 = ['', '出团日期开始前', '回团日期截止前', '回团日期截止后']
                listText[1].allBookingType = arr2[Number(rules.allBookingType)]
                if (rules.allBookingDate) {
                    listText[1].allBookingDate = rules.allBookingDate
                }
                if (rules.allBookingHours) {
                    listText[1].allBookingHours = rules.allBookingHours
                }
                if (rules.allBookingMinute) {
                    listText[1].allBookingMinute = rules.allBookingMinute
                }
            }
            return listText;
        }
    },
    created(){
        this.getDicts('cancel_type').then(res => { this.cancelTypeOptions = res.data })
        this.getDicts('line_product_cancel_feel_type').then(res => { this.cancelFeeTypeOptions = res.data })
    },
    mounted() {
        // this.formData = this.lineNewData
        this.formData = {
            productDesc: this.productDesc,
            productRules: this.productRules
        }
    },
    methods: {
        cancelFormat(value) {
            if(this.cancelTypeOptions.length > 0){
                let obj = this.cancelTypeOptions.find(item =>{
                    return item.dictValue === value
                })
                return obj && obj.dictLabel
            }else {
                return ""
            }

        },
        cancelFeeTypeFormat(value){
            if(this.cancelFeeTypeOptions.length > 0){
                let obj =  this.cancelFeeTypeOptions.find(item =>{
                    return item.dictValue == value
                })
                return obj && obj.dictLabel
            }else {
                return ""
            }
        }
    }
  }
</script>

<style scoped lang="scss">
.box {
    padding: 0 vw(20);
    .title {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        div {
            font-size: vw(27);
            margin-left:vw(20);
        }
    }
    .content {
        display: flex;
        color: #9c9c9c;
        justify-content: flex-start;
        font-size: vw(26);
        padding:vw(10) 0;
        span {
            // width: vw(2);
            margin: 0 vw(6);
            // background-color: #ddd;
        }
        div {
            margin: vw(20) vw(10);
        }
    }
    
    .advance-box {
        display:flex;
        justify-content: flex-start;
        padding:vw(10) 0;
        font-size: vw(26);
        color: #9c9c9c;
        .col-span {
            width: vw(2);
            margin: 0 vw(20);
            background-color: #ddd;
        }
        .content-box {
            display:flex;
            flex-direction:column;
            border: 1px solid #ddd;
            border-bottom: none;
            .advance-content {
                color: #9c9c9c;
                font-size: vw(26);
                align-items: center;
                border-bottom: 1px solid #ddd;
                .advance-title {
                    width:vw(55);
                    white-space: nowrap;
                    padding: vw(12)
                }
                .content-text {
                    border-left: 1px solid #ddd;
                    padding: vw(12)
                }
            }
        }
    }
    .rule {
        display: flex;
        color: #9c9c9c;
        justify-content: flex-start;
        font-size: vw(26);
        padding-top:vw(10);
        .rule_span {
            // width: vw(1);
            margin: 0 vw(6);
            // background-color: #ddd;
        }
        .rule_content {
            margin: vw(20) 0;
            margin-left: vw(10);
        }
    }
}

</style>

